import { createContext, useContext } from 'react';

type MenuContextState = {
  toggleMenu: () => void;
};

export const MenuContext = createContext<MenuContextState>({
  toggleMenu: () => {},
});

export const useMenuState = () => useContext(MenuContext);
